import { ProcedureTypes, TissueType, TissueProcedureConfig, TissueTypes } from "../../models";

export const getCreatedTissuesForProcedureType = (
    procedureType: ProcedureTypes,
    tissueTypes: TissueType[]
): TissueProcedureConfig[] => {
    if (procedureType === ProcedureTypes.ScleraPreservationHalf) {
        const sclera1Type = tissueTypes.find((tt) => tt.name === TissueTypes.Sclera1);
        const sclera2Type = tissueTypes.find((tt) => tt.name === TissueTypes.Sclera2);
        return sclera1Type && sclera2Type
            ? [
                  { tissueTypeId: sclera1Type.id, copyInitialGrading: false },
                  { tissueTypeId: sclera2Type.id, copyInitialGrading: false },
              ]
            : [];
    } else if (procedureType === ProcedureTypes.ScleraPreservationQuarter) {
        const quarter1Type = tissueTypes.find((tt) => tt.name === TissueTypes.Quarter1);
        const quarter2Type = tissueTypes.find((tt) => tt.name === TissueTypes.Quarter2);
        const quarter3Type = tissueTypes.find((tt) => tt.name === TissueTypes.Quarter3);
        const quarter4Type = tissueTypes.find((tt) => tt.name === TissueTypes.Quarter4);
        return quarter1Type && quarter2Type && quarter3Type && quarter4Type
            ? [
                  { tissueTypeId: quarter1Type.id, copyInitialGrading: false },
                  { tissueTypeId: quarter2Type.id, copyInitialGrading: false },
                  { tissueTypeId: quarter3Type.id, copyInitialGrading: false },
                  { tissueTypeId: quarter4Type.id, copyInitialGrading: false },
              ]
            : [];
    } else {
        return [];
    }
};
